import customer from 'app/entities/customer/customer.reducer';
import contact from 'app/entities/contact/contact.reducer';
import address from 'app/entities/address/address.reducer';
import bankAccount from 'app/entities/bank-account/bank-account.reducer';
import organisation from 'app/entities/organisation/organisation.reducer';
import employee from 'app/entities/employee/employee.reducer';
import customerAccount from 'app/entities/customer-account/customer-account.reducer';
import productOrder from 'app/entities/product-order/product-order.reducer';
import invoice from 'app/entities/invoice/invoice.reducer';
import product from 'app/entities/product/product.reducer';
import productOffering from 'app/entities/product-offering/product-offering.reducer';
import productSpecification from 'app/entities/product-specification/product-specification.reducer';
import productOfferingPrice from 'app/entities/product-offering-price/product-offering-price.reducer';
import ean from 'app/entities/ean/ean.reducer';
import tariff from 'app/entities/tariff/tariff.reducer';
import taxTariffTranche from 'app/entities/tax-tariff-tranche/tax-tariff-tranche.reducer';
import customerOrder from 'app/entities/customer-order/customer-order.reducer';
import agreement from 'app/entities/agreement/agreement.reducer';
import supplier from 'app/entities/supplier/supplier.reducer';
import department from 'app/entities/department/department.reducer';
import serviceOrder from 'app/entities/service-order/service-order.reducer';
import workOrder from 'app/entities/work-order/work-order.reducer';
import task from 'app/entities/task/task.reducer';
import meter from 'app/entities/meter/meter.reducer';
import dynamicTariff from 'app/entities/dynamic-tariff/dynamic-tariff.reducer';
import dailyProductUsage from 'app/entities/daily-product-usage/daily-product-usage.reducer';
import hourlyProductUsage from 'app/entities/hourly-product-usage/hourly-product-usage.reducer';
import monthlyProductUsage from 'app/entities/monthly-product-usage/monthly-product-usage.reducer';
import login from 'app/entities/login/login.reducer';
import gridOperator from 'app/entities/grid-operator/grid-operator.reducer';
import gridOperatorCapacityTariff from 'app/entities/grid-operator-capacity-tariff/grid-operator-capacity-tariff.reducer';
import gridOperatorCapacity from 'app/entities/grid-operator-capacity/grid-operator-capacity.reducer';
import tariffHistory from 'app/entities/tariff-history/tariff-history.reducer';
import taxTariffTrancheHistory from 'app/entities/tax-tariff-tranche-history/tax-tariff-tranche-history.reducer';
import correctionFactor from 'app/entities/correction-factor/correction-factor.reducer';
import errorMessage from 'app/entities/error-message/error-message.reducer';
import sectorCalendar from 'app/entities/sector-calendar/sector-calendar.reducer';
import productProcess from 'app/entities/product-process/product-process.reducer';
import productProcessHistory from 'app/entities/product-process-history/product-process-history.reducer';
import mandate from 'app/entities/mandate/mandate.reducer';
import relationCustomer from 'app/entities/relation-customer/relation-customer.reducer';
import signingSession from 'app/entities/signing-session/signing-session.reducer';
import contractSignature from 'app/entities/contract-signature/contract-signature.reducer';
import signatureAuditLog from 'app/entities/signature-audit-log/signature-audit-log.reducer';
import netMeteringPolicy from 'app/entities/net-metering-policy/net-metering-policy.reducer';
import subCaptar from 'app/entities/sub-captar/sub-captar.reducer';
import productTariffOverride from 'app/entities/product-tariff-override/product-tariff-override.reducer';
import tariffPricingConstraint from 'app/entities/tariff-pricing-constraint/tariff-pricing-constraint.reducer';
import contactRms from 'app/entities/contact-rms/contact-rms.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  customer,
  contact,
  address,
  bankAccount,
  organisation,
  employee,
  customerAccount,
  productOrder,
  invoice,
  product,
  productOffering,
  productSpecification,
  productOfferingPrice,
  ean,
  tariff,
  taxTariffTranche,
  customerOrder,
  agreement,
  supplier,
  department,
  serviceOrder,
  workOrder,
  task,
  meter,
  dynamicTariff,
  dailyProductUsage,
  hourlyProductUsage,
  monthlyProductUsage,
  login,
  gridOperator,
  gridOperatorCapacityTariff,
  gridOperatorCapacity,
  tariffHistory,
  taxTariffTrancheHistory,
  correctionFactor,
  errorMessage,
  sectorCalendar,
  productProcess,
  productProcessHistory,
  mandate,
  relationCustomer,
  netMeteringPolicy,
  signingSession,
  contractSignature,
  signatureAuditLog,
  subCaptar,
  productTariffOverride,
  tariffPricingConstraint,
  contactRms,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
